import React from 'react'
import { cn } from '@/shared/lib/utils'

export interface FeatureHeaderProps {
    title: React.ReactNode
    subtitle?: React.ReactNode
    actions?: React.ReactNode
    className?: string
    children?: React.ReactNode
}

export const FeatureHeader = ({
    title,
    subtitle,
    actions,
    className,
    children
}: FeatureHeaderProps) => {
    return (
        <div className={cn("flex-none space-y-4 w-full min-w-0", className)}>
            <div className="flex justify-between items-start gap-4 w-full min-w-0">
                <div className="flex-1 min-w-0">
                    <h1 className="text-2xl font-bold mb-1 truncate max-w-prose" title={typeof title === 'string' ? title : undefined}>
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="text-sm text-muted-foreground truncate">
                            {subtitle}
                        </p>
                    )}
                </div>
                {actions && (
                    <div className="flex gap-2 items-center flex-shrink-0">
                        {actions}
                    </div>
                )}
            </div>
            {children}
        </div>
    )
}
